document.addEventListener("DOMContentLoaded", function () {
    const zoomLevel = 2; // Adjust zoom level as needed

    // Select all zoom images
    const zoomImages = document.querySelectorAll('.zoom-image');

    zoomImages.forEach(image => {
        const zoomBox = image.parentElement.nextElementSibling; // Assuming the zoom box is the next sibling
        if (zoomBox) {
            // Mousemove event for zooming
            image.addEventListener('mousemove', function (e) {
              const rect = image.getBoundingClientRect();
              
              const xPos = e.clientX - rect.left;
              const yPos = e.clientY - rect.top;
                          
              // Calculate background position in zoom box
              const xPercent = (xPos / image.width) * 100;
              const yPercent = (yPos / image.height) * 100;
              const zoomBoxHalfWidth  = zoomBox.offsetWidth / 2;
              const zoomBoxHalfHeight = zoomBox.offsetHeight / 2;
              
              zoomBox.style.display = "block";
              
              if( ( e.clientX - zoomBoxHalfWidth ) >= rect.left && ( e.clientX + zoomBoxHalfWidth ) <= rect.right ) {
                zoomBox.style.left = `${xPos - zoomBoxHalfWidth}px`;                
              } else {
                if( ( e.clientX - zoomBoxHalfWidth ) <= rect.left ) {
                  zoomBox.style.left = 0;                  
                } else {
                  zoomBox.style.left = `${(rect.right - rect.left) - zoomBox.offsetWidth}px`;                  
                }
              }

              if( ( e.clientY - zoomBoxHalfHeight ) >= rect.top && ( e.clientY + zoomBoxHalfHeight ) <= rect.bottom ) {
                zoomBox.style.top = `${yPos - zoomBoxHalfHeight}px`;                
              } else {
                if( ( e.clientY - zoomBoxHalfHeight ) <= rect.top ) {
                  zoomBox.style.top = 0;                  
                } else {
                  zoomBox.style.top = `${(rect.bottom - rect.top) - zoomBox.offsetHeight}px`;                  
                }
              }
              
              zoomBox.style.backgroundImage = `url(${image.src})`;
              zoomBox.style.backgroundSize = `${image.width * zoomLevel}px ${image.height * zoomLevel}px`;
              zoomBox.style.backgroundPosition = `${xPercent}% ${yPercent}%`;
            });

            // Hide the zoom box when mouse leaves the image
            image.addEventListener('mouseleave', function () {
                zoomBox.style.display = "none";
            });
        }
    });
});
